// extracted by mini-css-extract-plugin
export default {"pageBottomBrand":"index_pageBottomBrand_UHTZx","pageBottomBrandPic":"index_pageBottomBrandPic_1aXaS"};